<template>
    <div>

        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-calendar"></i>
                Planning verkoop
            </h2>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#planningFormRequest" aria-expanded="true" aria-controls="planningFormRequest">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': this.componentIsVisable}" id="planningFormRequest">

                <div class="text-decoration-none text-nowrap me-4 mb-3 text-end " role="button">
                <span class="bg-lightyellow text-primary round-btn me-2">
                    <i class="fa fa-link" aria-hidden="true"></i>
                </span>
                    <a href="planning-form-request" class="fw-semibold" style="text-decoration: none;">
                        Naar planning verkoop
                    </a>
                </div>

                <div class="agenda">
                    <div class="app-planning bg-light p-3">
                        <div>
                            <FullCalendar id="calendar" ref="calendar" :options="calendarOptions" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin, {Draggable} from '@fullcalendar/interaction';
import nlLocale from '@fullcalendar/core/locales/nl';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from "moment/moment";
import {EventBus} from "../../../event-bus";
import {useComponentVisibility} from "../../../composables/useComponentVisibility";

export default {
    name: 'planning-assembly',
    components: {
        FullCalendar
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            calendarOptions: {
                /** init fullCalendar plugins */
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridDay',
                //allDaySlot: false,
                height: '500px',
                eventDisplay: 'block',
                displayEventEnd: true,
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: '',
                },
                events: [{
                    id: '',
                    title: '',
                    date: '',
                    start_time: '',
                    end_time: '',
                }],
                //weekNumbers: true,

                /** actions */
                eventClick: this.showEvent,
                customButtons: {
                    prev: {
                        click: () => {
                            this.loading = true;
                            let calendarApi = this.$refs.calendar.getApi();
                            calendarApi.prev();
                            this.getEvents();
                        }
                    },
                    next: { // this overrides the next button
                        click: () => {
                            this.loading = true;
                            let calendarApi = this.$refs.calendar.getApi();
                            calendarApi.next();
                            this.getEvents();
                        }
                    }
                },

                /** Time */
                locale: nlLocale,
                displayEventTime: true,
                slotMinTime: "06:00:00",
                slotMaxTime: "20:00:00",
                eventTimeFormat: {
                    hour: 'numeric',
                    minute: '2-digit',
                    omitZeroMinute: false,
                    meridiem: false
                },
            },

            users: [],
            plannedEvents: [],
            modal: {
                component: null,
                show: false,
                event: null,
                date_string: null,
            },

                componentId: 'planning-form-request-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                if (!this.componentIsVisable) {
                    this.loading = true;
                }

                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                })
                .then(response => {
                    this.getEvents();
                 });
            },
            getEvents() {
                let calendarApi = this.$refs.calendar.getApi();
                let view = calendarApi.view;

                let activeDate = this.formatDate(view.activeStart);

                axios.get('api/get-planning-form-request-items?&date='+activeDate)
                    .then(response => {
                        if (response.data.status === 422) {
                            throw [true, response.data.message];
                        }

                       // calendarApi.removeAllEvents();

                        this.users = response.data.users;
                        this.plannedEvents = response.data.plannedEvents;

                        this.addEventsToCalendar();

                        this.componentId = response.data.componentId;
                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
        },
        addEventsToCalendar() {
            this.calendarOptions.events = [];

            for (const [index, user] of Object.entries(this.users)) {
                this.addEventsPlanned(user.id);
            }
        },
        addEventsPlanned(user_id) {
            if (this.plannedEvents[user_id] !== undefined) {
                for (let event of this.plannedEvents[user_id]) {
                    event.start = moment(event.date + ' ' + event.start_time).toDate();
                    event.end = moment(event.date + ' ' + event.end_time).toDate();

                    this.calendarOptions.events.push(event);
                }
            }
        },
        showEvent(event) {
            axios.get('api/get-planning-form-request-item/'+event.event.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    EventBus.$emit('showCalendarEvent', response.data);
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });

        },
        formatDate(date) {
            return date.getFullYear() + '-' + this.prependZero((date.getMonth()+1)) + '-' + this.prependZero(date.getDate())
        },
        prependZero(number) {
            return number.toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        },
    },
    mounted() {
        this.getEvents();
        this.loading = false;
    },
    created() {},
}
</script>

<style>
.fc .fc-daygrid-event-harness {
    cursor: pointer !important;
}
</style>
